module.exports = __webpack_public_path__ + "static/media/icono-play.d147f16f.svg";